import {useAppSelector} from "./redux";
import {useEffect, useState} from "react";
import {IGpsrProduct} from "../store/slices/gpsrProductsSlice";

type itemsType = IGpsrProduct[] | [];

export const usePagination = () => {
    const {products} = useAppSelector((state) => state.gpsrProducts);

    const [loading, setLoading] = useState<boolean>(false);
    const [page, setPage] = useState<number>(1);
    const [total, setTotal] = useState<number>(0);
    const [pageSize, setPageSize] = useState<number>(8);
    const [items, setItems] = useState<itemsType>([]);

    const totalPages = Math.ceil(total / pageSize);
    const startItem = (page - 1) * pageSize;
    const endItem = Math.min(page * pageSize, total);

    const handlePageChange = (direction: 'prev' | 'next') => {
        const newPage = direction === 'next' ? page + 1 : page - 1;
        setPage(newPage);
    };

    useEffect(() => {
        setItems(products.slice(startItem, endItem));
        setTotal(products.length)
        setLoading(true);
        setTimeout(() => {
            setItems(products.slice(startItem, endItem));
            setLoading(false);
        }, 500);
    }, [page, products, startItem, endItem, total]);

    return {startItem, endItem, total, items, loading, page, totalPages, handlePageChange};
}